import { HttpResponse, ServiceClient } from '@johnlewispartnership/wtr-website-api-client';
import config from 'config';
import {
  type Eligibility,
  EligibilityReason,
  EligibilityStatus,
  type Ineligible,
} from 'services/intelligentShoppingExperience/types';
import { logApiError } from 'logger';
import getApiBaseUrl from 'utils/getApiBaseUrl';

export const defaultEligibility: Ineligible = {
  status: EligibilityStatus.INELIGIBLE,
  reason: EligibilityReason.FEATURE_DISABLED,
};

class IntelligentShoppingExperienceServiceClient extends ServiceClient {
  async getEligibility({ authHeader }: { authHeader: string }): Promise<Eligibility> {
    const { data, error, duration, status } = await this.httpClient
      .get<Eligibility>('/v1/eligibility', {
        headers: {
          Authorization: authHeader,
          breadcrumb: config.applicationName,
        },
      })
      .catch(e => ({ error: e }) as HttpResponse<Eligibility>);

    if (!data || error) {
      logApiError({
        payload: {
          service: 'intelligentShoppingExperience',
          duration,
          httpStatus: String(status || ''),
          httpStatusCode: status,
          url: `${getApiBaseUrl(config.services.intelligentShoppingExperience.path)}/v1/eligibility`,
          message: `Error getting eligibility: ${
            error?.message || 'Eligibility missing from response'
          }`,
        },
      });

      return defaultEligibility;
    }

    return data;
  }
}

const intelligentShoppingExperienceServiceClient = new IntelligentShoppingExperienceServiceClient(
  getApiBaseUrl(config.services.intelligentShoppingExperience.path),
);

export default intelligentShoppingExperienceServiceClient;
